import { RequestBuilder } from "../requestBuilder";
import {
  AddAttachmentToLibraryBodySchema,
  AddAttachmentToLibraryResponseSchema,
  ArtifactSignedUrlsBodySchema,
  ArtifactSignedUrlsResponseSchema,
  AttachmentIdParamsSchema,
  ConfirmAttachmentUploadResponseSchema,
  CreateAttachmentBodySchema,
  CreateAttachmentResponseSchema,
} from "./artifactsClient.types";

// POST /artifacts/attachments - Create a pending prompt attachment and a signed upload URL
export const CreateAttachmentRequestConfig = new RequestBuilder({
  path: () => "/artifacts/attachments",
  bodySchema: CreateAttachmentBodySchema,
  responseSchema: CreateAttachmentResponseSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

// PUT /artifacts/attachments/{artifactId}/uploaded - Confirm the upload; a file over its type's
// limit, or whose bytes aren't a supported image or PDF, is deleted and refused with
// artifacts.attachments.uploaded.too_large or .unsupported_type
export const ConfirmAttachmentUploadRequestConfig = new RequestBuilder({
  paramsSchema: AttachmentIdParamsSchema,
  responseSchema: ConfirmAttachmentUploadResponseSchema,
  path: (params) => `/artifacts/attachments/${encodeURIComponent(params.artifactId)}/uploaded`,
})
  .withMethod("PUT")
  .withContentType(undefined)
  .withIncludeProjectId();

// POST /artifacts/attachments/{artifactId}/library - Add a file already sent in the chat to the
// Library; one already there answers with its existing asset
export const AddAttachmentToLibraryRequestConfig = new RequestBuilder({
  paramsSchema: AttachmentIdParamsSchema,
  bodySchema: AddAttachmentToLibraryBodySchema,
  responseSchema: AddAttachmentToLibraryResponseSchema,
  path: (params) => `/artifacts/attachments/${encodeURIComponent(params.artifactId)}/library`,
})
  .withMethod("POST")
  .withIncludeProjectId();

// POST /artifacts/signed-urls - Read URLs for artifacts, tool output and prompt attachments alike
export const ArtifactSignedUrlsRequestConfig = new RequestBuilder({
  path: () => "/artifacts/signed-urls",
  bodySchema: ArtifactSignedUrlsBodySchema,
  responseSchema: ArtifactSignedUrlsResponseSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();
